import React from 'react'
import InfoIcon from '../InfoIcon/Index'
import CheckIcon from '../../images/check.svg'
import XIcon from '../../images/x.svg'
import Tooltip from 'components/Tooltip'

type FeatureAvailabilityProps = {
    availability:
        | {
              complete?: boolean
              free: boolean
              selfServe: boolean
              enterprise: boolean
          }
        | boolean
}

const renderAvailabilityIcon = (isAvailable: boolean) => {
    return isAvailable ? (
        <img src={CheckIcon} alt="Available" className="mr-2 h-4 w-4" aria-hidden="true" />
    ) : (
        <img src={XIcon} alt="Not available" className="mr-2 h-4 w-4" aria-hidden="true" />
    )
}

export function FeatureAvailability({ availability }: FeatureAvailabilityProps): JSX.Element {
    const diffComplete = typeof availability !== 'boolean' && 'complete' in availability

    return (
        <div className="mt-2 mb-5 space-y-2 border-t border-b border-dashed border-gray-accent-light py-2 dark:border-gray-accent-dark ">
            <h6 className="!my-0 text-base font-semibold text-primary/50 dark:text-primary-dark/50">
                Where is this feature available?
            </h6>

            <div
                className={`grid grid-flow-col-dense ${
                    diffComplete
                        ? 'grid-cols-2 grid-rows-4 sm:grid-cols-4 sm:grid-rows-2'
                        : 'grid-cols-2 grid-rows-3 sm:grid-cols-3 sm:grid-rows-2'
                } items-center gap-x-4 sm:grid-flow-row-dense`}
            >
                {diffComplete ? (
                    <div>
                        <h5 className="!my-0 flex items-center space-x-1.5 text-base">
                            <span>Light</span>
                            <Tooltip content="Light">
                                <span>
                                    <InfoIcon className="h-4 w-4" />
                                </span>
                            </Tooltip>
                        </h5>
                    </div>
                ) : null}

                <div>
                    <h5 className="!my-0 flex items-center space-x-1.5 text-base">
                        {diffComplete ? <span>Free</span> : <span>Light</span>}
                        <Tooltip content="iCloudReady Cloud (no credit card added) or FOSS">
                            <span>
                                <InfoIcon className="h-4 w-4" />
                            </span>
                        </Tooltip>
                    </h5>
                </div>

                <div>
                    <h5 className="!my-0 flex items-center space-x-1.5 text-base">
                        <span>Standard</span>
                        <Tooltip content="iCloudReady Cloud or On-permiseed (with credit card entered)">
                            <span>
                                <InfoIcon className="h-4 w-4" />
                            </span>
                        </Tooltip>
                    </h5>
                </div>

                <div>
                    <h5 className="!my-0 flex items-center space-x-1.5 text-base">
                        <span>Enterprise</span>
                        <Tooltip content="iCloudReady Cloud or On-permiseed (with enterprise license)">
                            <span>
                                <InfoIcon className="h-4 w-4" />
                            </span>
                        </Tooltip>
                    </h5>
                </div>

                {diffComplete ? renderAvailabilityIcon(availability.complete || false) : null}

                {renderAvailabilityIcon(typeof availability === 'boolean' ? availability : availability.free)}

                {renderAvailabilityIcon(typeof availability === 'boolean' ? availability : availability.selfServe)}

                {renderAvailabilityIcon(typeof availability === 'boolean' ? availability : availability.enterprise)}
            </div>
        </div>
    )
}
